package io.horion.cv.api.datasource.cv

import io.horion.cv.api.datasource.common.PersonalInformation
import io.horion.cv.api.datasource.common.Signature
import io.horion.cv.api.datasource.common.Type
import kotlinx.serialization.Serializable
import kotlinx.serialization.json.Json


@Serializable
data class OrionCV(
    @kotlinx.serialization.SerialName("_id")
    val id: String = "",
    val uuid: String = "",
    val user: String? = null,
    val owner: String? = null,
    val personalInformation: PersonalInformation,
    val cvTitle: String = "",
    val profil: String? = null,
    val formations: List<Formation> = emptyList(),
    val experiences: List<Experience> = emptyList(),
    val competences: List<Competence> = emptyList(),
    val languages: List<LanguageItem> = emptyList(),
    val hobbies: List<String> = emptyList(),
    val qualities: List<String> = emptyList(),
    val certificates: List<Certificate> = emptyList(),
    val stages: List<Stage> = emptyList(),
    val software: List<Software> = emptyList(),
    //val skills: List<Skill> = emptyList(),
    val learns: List<Learn> = emptyList(),
    val achievements: List<String> = emptyList(),
    val references: List<Reference> = emptyList(),
    val extracurricularActivities: List<Activity> = emptyList(),
    val personalizedSections: List<Section> = emptyList(),
    val signature: Signature? = null,
    val others: List<String> = emptyList(),
    val associativeLife : List<AssociativeLife> = emptyList(),
    val cvConfig: CvConfig? = null,
    val type: Type = Type.PERSONNEL,
)